'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import VideoTextCard from '@/components/VideoTextCard';
import card1Data from '../../../textContent/education/card1Data.json';
import card2Data from '../../../textContent/education/card2Data.json';
import { motion } from 'framer-motion';
/* ---------------- Animation Variant ---------------- */
const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: 'easeOut' },
    },
};

const page = () => {
    const heroTextContent = {
        heading: 'Educate Brighter, Manage Smoother',
        caption:
            'Analyze student performance, track course effectiveness, and identify areas for improvement. These insights empower data-driven decisions.',
        image: '/images/hero/education.png',
        buttonText: 'Talk to Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero animation */}
            <motion.div initial="hidden" animate="visible" variants={fadeUp}>
                <Hero {...heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <VideoTextCard data={card1Data} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
            >
                <VideoTextCard data={card2Data} />
            </motion.div>
        </Fragment>
    );
};

export default page;
